import { CustomDomainType } from '@va/shared/api/custom-domains';
import { useListCompanyDomains } from '@va/shared/custom-domains/lib/company-domains/useListCompanyDomains';
import { selectAgencyId } from '@va/standalone/shared/selectors';
import { useSelector } from 'react-redux';

export const useAgencyCustomDashboardDomains = () => {
  return useAgencyCustomDomains(CustomDomainType.dashboard);
};

export const useAgencyCustomSupportCenterDomains = () => {
  return useAgencyCustomDomains(CustomDomainType.supportCenter);
};

export const useAgencyCustomDomains = (type: CustomDomainType) => {
  const agencyId = useSelector(selectAgencyId);

  return useListCompanyDomains({ companyId: agencyId ?? '', domainType: type });
};
